import { adminHttpClient } from '../../commons/adminHttpClient'
import { BenefitDesignStatus } from '../../../domain/benefit/benefitDesignStatus'

export interface PlanPeriodDto {
  id: string
  startDate: string
  endDate: string
  notificationDate: string
  benefitDesignStatus: BenefitDesignStatus
  allowanceType: number
  sameClassForAll: boolean
  active: boolean
  hasActiveRunOutPeriod: boolean
  runOutPeriodYear?: number
  isContinuous: boolean
}

type BenefitPlanPeriodsFilter = {
  onlyPlanPeriodsWithNotificationDateDefined?: boolean
}
const benefitPlanPeriods = async (filter: BenefitPlanPeriodsFilter = {}): Promise<PlanPeriodDto[]> => {
  const result = await adminHttpClient.get('/AdminDashboard/BenefitDetails/BenefitPlanPeriods')
  if (filter.onlyPlanPeriodsWithNotificationDateDefined) {
    return result.filter((x: PlanPeriodDto) => x.notificationDate)
  }
  return result
}

export const getActivePlanPeriod = async (): Promise<PlanPeriodDto | null> => {
  const planPeriods = await benefitPlanPeriods()
  return planPeriods && planPeriods.length > 0 ? getActivePlanPeriodFromPlanPeriods(planPeriods) : null
}

export const getActivePlanPeriodFromPlanPeriods = (planPeriods: PlanPeriodDto[]): PlanPeriodDto => {
  if (!planPeriods || planPeriods.length == 0) throw new Error('No plan periods specified.')

  const active = planPeriods.find((x: PlanPeriodDto) => x.active)
  if (active) {
    return active
  }

  throw new Error('Could not find active plan period.')
}

export const getSelectedOrActivePlanPeriod = (planPeriods: PlanPeriodDto[], planPeriodId?: string) =>
  planPeriods.find(planPeriodId ? (x) => x.id === planPeriodId : (x) => x.active)

export default benefitPlanPeriods
